export function hasAlarmExpired (alarmTimestamp) {
  return Date.now() > alarmTimestamp
}

export function createAlarmTimeHoursFromNow (hours) {
  const millis = hours * 60 * 60 * 1000
  return Date.now() + millis
}

export function createAlarmTimeMinutesFromNow (minutes) {
  const millis = minutes * 60 * 1000
  return Date.now() + millis
}

export function createAlarmTimeSecondsFromNow (seconds) {
  const millis = seconds * 1000
  return Date.now() + millis
}

const TIME_OF_DAY_HOURS = { morning: 7, afternoon: 12, evening: 19, night: 0 }

// The half-open hour ranges each time-of-day slot covers, in local time:
//   morning   07:00–12:00
//   afternoon 12:00–19:00
//   evening   19:00–24:00
//   night     00:00–07:00
const TIME_OF_DAY_RANGES = {
  morning: [7, 12],
  afternoon: [12, 19],
  evening: [19, 24],
  night: [0, 7]
}

export const TIME_OF_DAY_ORDER = ['morning', 'afternoon', 'evening', 'night']

// Cycles to the next slot, wrapping back to morning. Used by free play's
// manual time-of-day advance, since there's no wall clock to read there.
export function getNextTimeOfDay (timeOfDay) {
  const index = TIME_OF_DAY_ORDER.indexOf(timeOfDay)
  return TIME_OF_DAY_ORDER[(index + 1) % TIME_OF_DAY_ORDER.length]
}

// The slot the given time falls in, or null if it's outside every slot.
export function getCurrentTimeOfDay (date = new Date()) {
  const hour = date.getHours()
  for (const [name, [start, end]] of Object.entries(TIME_OF_DAY_RANGES)) {
    if (hour >= start && hour < end) return name
  }
  return null
}

// Whether "now" (or the given time) falls within the slot named by timeOfDay.
export function isTimeOfDayNow (timeOfDay, date = new Date()) {
  return getCurrentTimeOfDay(date) === timeOfDay
}

export function createAlarmTimeForTimeOfDay (timeOfDay) {
  const hour = TIME_OF_DAY_HOURS[timeOfDay]
  const now = new Date()
  const target = new Date(now)
  target.setHours(hour, 0, 0, 0)
  if (target <= now) target.setDate(target.getDate() + 1)
  return target.getTime()
}

export function getSecondsUntilTimeOfDay (timeOfDay) {
  return Math.round((createAlarmTimeForTimeOfDay(timeOfDay) - Date.now()) / 1000)
}
